import React from "react";
import PageWrapper from "./common.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import OutstandingClaimReportTable from "components/report/OutstandingClaimReportTable";

const OutstandingClaimReport = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.report"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.outstanding_claim_report"
          }
        ]}
      />
      <div className="user-tbl">
        <OutstandingClaimReportTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.auth,
    ...state.themeChanger,
    auth: state.auth
  };
};

export default connect(mapStateToProps, null)(OutstandingClaimReport);
